module.exports = __webpack_public_path__ + "img/make-in-india.eea975e3.png";